module.exports = __webpack_public_path__ + "img/Rongrong_Ji@2x.6883ffb6.png";